import axios from "axios";
import authHeader from "./header";
import store from "@/store";
import alerts from "@/alerts/alert";

class Api {
  async doPost(url, params) {
    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + url,
      headers: authHeader(),
      data: params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doGet(url, params) {
    return await axios
      .get(process.env.VUE_APP_API + url, {
        params,
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }

        const gagal = {
          request_id: null,
          code: 400,
          status: error.response.data.message,
          message: error.response.data.message,
          errors: null,
          data: [],
          time_stamp: error.response.data.time_stamp,
        };
        return gagal;
      });
  }

  async doPaginate(url, params) {
    return await axios
      .get(process.env.VUE_APP_API + url, {
        params,
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }

        const gagal = {
          request_id: null,
          code: 400,
          status: error.response.data.message,
          message: error.response.data.message,
          data: {
            current_page: "",
            data: [],
            first_page_url: "",
            from: "",
            last_page: "",
            last_page_url: "",
            links: [
              {
                url: null,
                label: "",
                active: false,
              },
              {
                url: "",
                label: "",
                active: true,
              },
              {
                url: null,
                label: "",
                active: false,
              },
            ],
            next_page_url: "",
            path: "",
            per_page: "",
            prev_page_url: "",
            to: "",
            total: "",
          },
        };
        return gagal;
      });
  }

  async doPut(url, params) {
    return axios({
      method: "PUT",
      url: process.env.VUE_APP_API + url,
      headers: authHeader(),
      data: params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doDelete(url, params) {
    return axios
      .delete(process.env.VUE_APP_API + url, {
        params,
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doGetBlob(url, params) {
    return axios
      .get(process.env.VUE_APP_API + url, {
        params,
        responseType: "arraybuffer",
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doPostBlob(url, params) {
    return axios
      .post(process.env.VUE_APP_API + url, {
        params,
        responseType: "arraybuffer",
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doPostMultipart(url, params) {
    let header = authHeader();
    header["Content-Type"] = "multipart/form-data";
    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + url,
      headers: header,
      data: params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return Promise.reject(error);
      });
  }

  async doPutMultipart(url, params) {
    let header = authHeader();
    header["Content-Type"] = "multipart/form-data";
    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + url,
      headers: header,
      data: params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }

  async doGetDownload(url, params, file_name = "report") {
    return axios
      .get(process.env.VUE_APP_API + url, {
        params,
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          this.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
        headers: authHeader(),
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file_name + ".xlsx");
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.remove();
        window.URL.revokeObjectURL(url);
        return response.data;
      })
      .catch((error) => {
        alert("error");
        if (
          error.response.status === 401 &&
          store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/refreshToken");
        } else if (
          error.response.status === 401 &&
          !store.getters["auth/remember_me"]
        ) {
          store.dispatch("auth/LogOut");
        } else {
          alerts.sweetalertToast("error", error.response.data.message);
        }

        if (error.response.data.code === 403) {
          store.dispatch("auth/LogOut");
        }
        return error.response.data;
      });
  }
}

export default new Api();
